import { useParams } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SchemaOrg from '@/components/feature/SchemaOrg';
import CategoryHero from './components/CategoryHero';
import ComicGrid from './components/ComicGrid';
import CategoryCTA from './components/CategoryCTA';
import { categories } from '@/mocks/data';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const currentSlug = slug || 'romance';
  const category = categories.find((c) => c.slug === currentSlug) || categories[0];

  return (
    <>
      <SchemaOrg type="WebPage" data={{
        name: `${category.name}漫画 - 韩漫屋`,
        url: `http://pedionline.com/category/${currentSlug}`,
        description: `韩漫屋${category.name}漫画分类，收录海量${category.name}题材免费韩漫，每日更新热门好看的韩国漫画。`,
        isPartOf: { '@type': 'WebSite', name: '韩漫屋', url: 'http://pedionline.com/' },
      }} />
      <SchemaOrg type="BreadcrumbList" data={{
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '首页', item: 'http://pedionline.com/' },
          { '@type': 'ListItem', position: 2, name: `${category.name}漫画`, item: `http://pedionline.com/category/${currentSlug}` },
        ],
      }} />

      <Navbar />
      <Breadcrumb items={[
        { label: '首页', path: '/' },
        { label: `${category.name}漫画` },
      ]} />

      <main>
        <CategoryHero slug={currentSlug} />
        <ComicGrid currentSlug={currentSlug} />
        <CategoryCTA slug={currentSlug} categoryName={category.name} />
      </main>

      <Footer />
    </>
  );
}